export const sanitizeStr = (str = '') => str.replace(/"/g, '\\"').trim();
